import {Component, ElementRef, inject, input} from '@angular/core';
import {AppRoute, NavigationService} from '../../services/navigation.service';
import {NavigationExtras} from '@angular/router';


@Component({
  selector: 'app-link',
  standalone: true,
  imports: [],
  templateUrl: './link.component.html',
  styleUrl: './link.component.css'
})
export class LinkComponent {
  href = input<AppRoute | [AppRoute, ...string[]] | null>(null);
  extras = input<NavigationExtras>();
  disabled = input<boolean>(false);
  title = input<string>('');

  private navigation = inject(NavigationService);
  elementRef = inject(ElementRef<HTMLElement>);

  constructor() {
    // Capture phase so this runs before the parent's (click) binding on this
    // same host element, which Angular otherwise attaches as a bubble-phase
    // listener with no guaranteed ordering relative to this one.
    this.elementRef.nativeElement.addEventListener('click', (event: MouseEvent) => {
      if (this.disabled()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, {capture: true});
  }

  clicked() {
    if (this.disabled()) return;

    const href = this.href();

    if (href) {
      this.navigation.navigate(href, this.extras());
    }
  }
}
